import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recorrido-resumen-small',
  templateUrl: './recorrido-resumen-small.component.html',
  styleUrls: ['./recorrido-resumen-small.component.scss']
})
export class RecorridoResumenSmallComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
